var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.23;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0.322)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(0 -0.322)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.193 2.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.807,2a9.807,9.807,0,1,0,9.807,9.807A9.81,9.81,0,0,0,11.807,2Zm7.316,6.982L16.4,10.11A4.886,4.886,0,0,0,13.5,7.227L14.631,4.5A7.808,7.808,0,0,1,19.122,8.982Zm-7.316,5.766a2.942,2.942,0,1,1,2.942-2.942A2.938,2.938,0,0,1,11.807,14.748ZM8.992,4.491l1.147,2.726A4.9,4.9,0,0,0,7.217,10.13L4.491,8.992A7.83,7.83,0,0,1,8.992,4.491Zm-4.5,10.13,2.726-1.128a4.872,4.872,0,0,0,2.913,2.9L8.982,19.122A7.841,7.841,0,0,1,4.491,14.621Zm10.14,4.5L13.5,16.4A4.882,4.882,0,0,0,16.4,13.483l2.726,1.147A7.853,7.853,0,0,1,14.631,19.122Z",
    transform: "translate(-2 -2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.53e35ed5fd49dcc1f58670bb97125670.svg";
export { ForwardRef as ReactComponent };